import Image from "next/image"

import { Buttons } from "components/Button"
import Hero from "components/Hero"
import Layout, { Container, Section } from "components/Layout"
import SEO from "components/Seo"
import { Heading, Lead } from "components/Text"
import Usps from "components/Usps"
import twoGearGuaranteeImg from "public/2-year-guarantee.svg"
import heroImg from "public/intruder-alarms-hero.webp"
import sectionTwoImg from "public/intruder-alarms-maintenance.webp"
import sectionOneImg from "public/intruder-alarms-supply.webp"
import sectionThreeImg from "public/maintenance-packages.webp"

import type { NextPage } from "next"

const IntruderAlarms: NextPage = () => {
  return (
    <>
      <SEO
        titleTag="Intruder Alarms Derbyshire | Alarm Installers | 3HCCTV &amp; Alarms"
        metaDescription="Our intruder alarm team specialise in burglar alarm installation for domestic &amp; commercial customers across Derbyshire, Nottinghamshire &amp; South Yorkshire."
        pageTitle="Intruder Alarms"
      />
      <Layout>
        <Hero
          image={heroImg}
          imageClass="!object-center"
          imageAlt="Intruder Alarms Derbyshire"
          heading="Intruder Alarms"
          subHeading="Leading intruder alarm specialist"
        />

        <Usps />

        <Section>
          <Container className="flex gap-6 smmax:flex-col-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Intruder alarm supply</Heading>
              <p>
                We supply a range of quality wired and wireless intruder
                prevention systems. Our fully trained burglar alarm installers
                can help to advise on the best system to suit your home or
                business requirements.
              </p>
              <Buttons
                buttons={[
                  { kind: "phone" },
                  {
                    href: "/products/wireless-alarm-system",
                    content: "Book online",
                    icon: "calendar-day"
                  }
                ]}
              />
            </div>
            <Image
              src={sectionOneImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Intruder alarm Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section variant="gray-100">
          <Container className="flex gap-6 smmax:flex-col-reverse mdmin:flex-row-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Intruder alarm installation</Heading>
              <p>
                Our intruder alarm installation service is second to none.
                Whether you require us to install a system you have already
                purchased, or one supplied by us. Our trained engineers can help
                to quickly install your intruder alarm and give you a
                demonstration on how it works once fitted.
              </p>

              <p className="text-sm">
                (Please note that intruder alarm system not supplied by 3H CCTV
                are not included in our warranty)
              </p>
              <Buttons
                buttons={[
                  { kind: "phone" },
                  {
                    href: "/products/wireless-alarm-system",
                    content: "Book online",
                    icon: "calendar-day"
                  }
                ]}
              />
            </div>
            <Image
              src={sectionTwoImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Intruder alarm installation Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section>
          <Container className="flex gap-6 smmax:flex-col-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Intruder alarm repairs &amp; maintenance</Heading>
              <p>
                We provide a burglar alarm and maintenance service across
                Derbyshire, South Yorkshire &amp; Nottinghamshire. From as
                little as £60 per year you can keep your intruder alarm fully
                maintained and covered for damages. Or if your existing burglar
                alarm is in need of repair. Our burglar alarm repair team can
                quickly get yours back up and running.
              </p>
              <Buttons
                buttons={[
                  { kind: "phone" },
                  {
                    href: "/products/wireless-alarm-system",
                    content: "Book online",
                    icon: "calendar-day"
                  }
                ]}
              />
            </div>
            <Image
              src={sectionThreeImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Intruder alarm maintenance packages Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section variant="gray-100" className="text-center">
          <Container>
            <Image
              src={twoGearGuaranteeImg}
              alt="2 year guarantee"
              className="w-[300px] mx-auto"
              sizes="300px"
            />
            <Heading
              underline={false}
              className="text-primary"
              alignment="center"
            >
              Our guarantee to you
            </Heading>
            <Lead>
              Every intruder alarm system supplied by 3H CCTV comes with our
              2-year guarantee for quality.
            </Lead>
          </Container>
        </Section>
      </Layout>
    </>
  )
}

export default IntruderAlarms
